var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 21H4.79999C4.5613 21 4.33238 20.9052 4.1636 20.7364C3.99482 20.5676 3.89999 20.3387 3.89999 20.1V3.9C3.89999 3.66131 3.99482 3.43239 4.1636 3.2636C4.33238 3.09482 4.5613 3 4.79999 3H19.2C19.4387 3 19.6676 3.09482 19.8364 3.2636C20.0052 3.43239 20.1 3.66131 20.1 3.9V20.1C20.1 20.3387 20.0052 20.5676 19.8364 20.7364C19.6676 20.9052 19.4387 21 19.2 21ZM18.3 19.2V4.8H5.69999V19.2H18.3ZM8.39999 7.5H15.6V9.3H8.39999V7.5ZM8.39999 11.1H15.6V12.9H8.39999V11.1ZM8.39999 14.7H12.9V16.5H8.39999V14.7Z",
    fill: "#2D9F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileList);
export default __webpack_public_path__ + "static/media/file-list.095314cf2c6e55d51d6f48090abf73e3.svg";
export { ForwardRef as ReactComponent };